import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content mdl-shadow--2dp is-casting-shadow" }
const _hoisted_2 = { class: "row strat-config align-items-center" }
const _hoisted_3 = { class: "col-lg-6 col-md-6 col-sm-4 col-xs-12" }
const _hoisted_4 = { class: "current-strategy d-flex align-items-center" }
const _hoisted_5 = { class: "fa-stack fa-lg" }
const _hoisted_6 = { class: "strat-name ms-2" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 col-sm-8 col-xs-12 d-flex justify-content-end align-items-center" }
const _hoisted_8 = { class: "pricing-configuration" }
const _hoisted_9 = { class: "selector" }
const _hoisted_10 = {
  class: "mdl-radio mdl-js-radio mdl-js-ripple-effect",
  for: "option-1"
}
const _hoisted_11 = {
  class: "mdl-radio mdl-js-radio mdl-js-ripple-effect mt-2",
  for: "option-2"
}
const _hoisted_12 = {
  class: "mdl-radio mdl-js-radio mdl-js-ripple-effect mt-2",
  for: "option-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingAccordionComponent = _resolveComponent("PricingAccordionComponent")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("i", {
              class: "fa fa-circle fa-stack-2x",
              style: _normalizeStyle({ color: _ctx.currentStrategy.color })
            }, null, 4),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fa fa-stack-1x strat-abbr" }, "C", -1))
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentStrategy.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "option-1",
                class: "mdl-radio__button",
                name: "options",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStrategyType) = $event)),
                value: 1,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStrategyChange && _ctx.handleStrategyChange(...args)))
              }, null, 544), [
                [_vModelRadio, _ctx.selectedStrategyType]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mdl-radio__label" }, " Apply same rules to all days (Mon-Sun) ", -1))
            ]),
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "option-2",
                class: "mdl-radio__button",
                name: "options",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStrategyType) = $event)),
                value: 2,
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleStrategyChange && _ctx.handleStrategyChange(...args)))
              }, null, 544), [
                [_vModelRadio, _ctx.selectedStrategyType]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mdl-radio__label" }, " Apply rules per day of week", -1))
            ]),
            _createElementVNode("label", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "option-3",
                class: "mdl-radio__button",
                name: "options",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStrategyType) = $event)),
                value: 3,
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleStrategyChange && _ctx.handleStrategyChange(...args)))
              }, null, 544), [
                [_vModelRadio, _ctx.selectedStrategyType]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "mdl-radio__label" }, " Apply rules down to the hour ", -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_PricingAccordionComponent, {
      strategy: _ctx.strategy,
      strategyType: _ctx.strategyType,
      onSeasonUpdated: _ctx.onSeasonUpdated,
      onSaveStrategy: _ctx.onSaveStrategy
    }, null, 8, ["strategy", "strategyType", "onSeasonUpdated", "onSaveStrategy"]),
    _createVNode(_component_ConfirmModal, {
      show: _ctx.showConfirmModal,
      message: "Changing this setting will remove your current utilization settings.",
      prompt: "Are you sure you wish to continue?",
      confirmText: "Yes",
      cancelText: "No",
      confirmType: "confirm-modal-btn-primary",
      cancelType: "confirm-modal-btn-danger",
      onConfirm: _ctx.onConfirmModal
    }, null, 8, ["show", "onConfirm"])
  ]))
}